var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179089",
    "data-name": "Group 179089",
    transform: "translate(-82 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146603",
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    transform: "translate(82 164)",
    fill: "#f3f6fa",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "code",
    transform: "translate(90.748 175.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21113",
    "data-name": "Path 21113",
    d: "M26.693,12.415,23.278,15.83l-.688-.688,2.722-2.727L22.59,9.688,23.278,9Z",
    transform: "translate(-11.764 -7.563)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21113_-_Outline",
    "data-name": "Path 21113 - Outline",
    d: "M23.248,8.646l3.738,3.738-3.738,3.738-1.011-1.011,2.722-2.727L22.237,9.658Zm3.092,3.738L23.248,9.293l-.365.365,2.722,2.727-2.722,2.727.365.365Z",
    transform: "translate(-11.734 -7.533)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21114",
    "data-name": "Path 21114",
    d: "M1,12.415,4.415,9l.688.688L2.381,12.415,5.1,15.142l-.688.688Z",
    transform: "translate(-1.426 -7.563)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21114_-_Outline",
    "data-name": "Path 21114 - Outline",
    d: "M4.385,8.646,5.4,9.658,2.674,12.385,5.4,15.112,4.385,16.123.646,12.385ZM4.75,9.658l-.365-.365L1.293,12.385l3.092,3.092.365-.365L2.027,12.385Z",
    transform: "translate(-1.396 -7.533)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27336",
    "data-name": "Path 27336",
    d: "M0,0H9.84V.976H0Z",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 5.507, 9.479)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27336_-_Outline",
    "data-name": "Path 27336 - Outline",
    d: "M0,0H10.3V1.433H0ZM9.84.457H.457V.976H9.84Z",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 5.227, 9.641)",
    fill: "#231f20"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/CodeIcon.0b4b508bf280f06c6e3549d445b88acd.svg";
export { ForwardRef as ReactComponent };